/**
 * This file contains all Databricks specific overrides for model-registry module. It should be
 * left EMPTY in OSS MLflow repo.
 */

export const ServiceOverrides = {};



// WEBPACK FOOTER //
// ./src/model-registry/overrides/service-overrides.js